<div class="search-results-container">
  <div class="filter-bar">
    <mat-form-field appearance="outline" class="search-field" style="width: 100%">
      <mat-label>Suche nach Name</mat-label>
      <input matInput [formControl]="searchControl" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>

  @if (isLoading) {
    <div class="state-indicator">
      <mat-spinner diameter="50"></mat-spinner>
      @if (this.searchControl.value) {
        <p>Suche nach "{{ this.searchControl.value }}"...</p>
      } @else {
        <p>Suche Raststätten in deiner Nähe...</p>
      }
    </div>
  }

  @if (error && !isLoading) {
    <div class="state-indicator">
      <mat-icon>error_outline</mat-icon>
      <p>{{ error }}</p>
      <p class="mat-caption">Du kannst trotzdem eine manuelle Suche starten.</p>
    </div>
  }

  @if (!isLoading && !error) {
    @if (this.searchControl.value) {
      <h2>Raststätten mit "{{ this.searchControl.value }}"</h2>
    } @else {
      <h2>Raststätten in deiner Nähe</h2>
    }
    <mat-list role="list">
      @for (stop of restStops; track stop.id) {
        <mat-list-item role="listitem" [routerLink]="['/', stop.slug]">
          <mat-icon matListItemIcon>assistant_navigation</mat-icon>
          <div matListItemTitle>{{ stop.name }}</div>
          <div matListItemLine>{{ stop.autobahn }}</div>
          <span matListItemMeta>{{ stop.distance | distance }}</span>
        </mat-list-item>
      } @empty {
        @if (this.searchControl.value === 'Feli') {
          <div class="state-indicator">
            <mat-icon>pets</mat-icon>

            <img src="assets/feli.webp" alt="Feli" style="width: 256px; height: 256px" />

            <p>200 - Feli found</p>
          </div>
        } @else {
          <div class="state-indicator">
            <mat-icon>search_off</mat-icon>
            <p>Keine Raststätte für deine Suche gefunden.</p>
          </div>
        }
      }
    </mat-list>
  }
</div>
